// extracted by mini-css-extract-plugin
module.exports = {"containerCarousel":"carouselHotelImages_containerCarousel__lqLi-","containerImg":"carouselHotelImages_containerImg__2smqs"};